import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { List, ListItem, ListItemText, Divider, Switch } from '@mui/material';
import CommonHeader from "../../base/views/CommonHeader";
import ApiService from "../../base/api/ApiService";
import { messagingReady, VAPID_KEY } from "../../firebaseConfig";
import { getToken } from "firebase/messaging";

const listItemTextStyle = { fontSize: '1.4rem', color: "black" };

type NotifState = 'granted' | 'denied' | 'default' | 'unsupported';

const handleLogout = () => {
    ApiService.logout();
    window.location.reload();
};

const ProfilePage: React.FC = () => {
    const [notifState, setNotifState] = useState<NotifState>('unsupported');

    useEffect(() => {
        if (!('Notification' in window)) {
            setNotifState('unsupported');
            return;
        }
        setNotifState(Notification.permission as NotifState);
    }, []);

    const handleEnableNotifications = async () => {
        try {
            const permission = await Notification.requestPermission();
            setNotifState(permission as NotifState);
            if (permission !== 'granted') return;

            const messaging = await messagingReady;
            if (!messaging) return;

            const swRegistration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
            await navigator.serviceWorker.ready;
            const token = await getToken(messaging, { vapidKey: VAPID_KEY, serviceWorkerRegistration: swRegistration });
            if (token) {
                await ApiService.registerDeviceToken(token, 'web');
            }
        } catch (e) {
            console.error('Enable notifications error:', e);
        }
    };

    const handleDisableNotifications = async () => {
        try {
            const messaging = await messagingReady;
            if (!messaging) return;

            const swRegistration = await navigator.serviceWorker.getRegistration('/firebase-messaging-sw.js');
            if (!swRegistration) return;
            const token = await getToken(messaging, { vapidKey: VAPID_KEY, serviceWorkerRegistration: swRegistration });
            if (token) {
                await ApiService.unregisterDeviceToken(token);
            }
        } catch (e) {
            console.error('Disable notifications error:', e);
        }
    };

    const handleNotifToggle = async () => {
        if (notifState === 'granted') {
            await handleDisableNotifications();
            setNotifState('default');
        } else {
            await handleEnableNotifications();
        }
    };

    const renderNotifItem = () => {
        if (notifState === 'unsupported') return null;

        if (notifState === 'denied') {
            return (
                <>
                    <ListItem>
                        <ListItemText
                            primaryTypographyProps={{ style: listItemTextStyle }}
                            primary="Уведомления"
                            secondaryTypographyProps={{ fontSize: '1.1rem' }}
                            secondary="Разрешите уведомления в настройках браузера"
                        />
                    </ListItem>
                    <Divider />
                </>
            );
        }

        return (
            <>
                <ListItem>
                    <ListItemText primaryTypographyProps={{ style: listItemTextStyle }} primary="Уведомления" />
                    <Switch checked={notifState === 'granted'} onChange={handleNotifToggle} />
                </ListItem>
                <Divider />
            </>
        );
    };

    return (
        <>
            <CommonHeader title="Профиль" />
            <div style={{ padding: '20px' }}>
                <List>
                    <ListItem component={Link} to="/changePassword">
                        <ListItemText primaryTypographyProps={{ style: listItemTextStyle }} primary="Сменить пароль" />
                    </ListItem>
                    <Divider />
                    {renderNotifItem()}
                    <ListItem component={Link} to="/agreement">
                        <ListItemText primaryTypographyProps={{ style: listItemTextStyle }} primary="Пользовательское соглашение" />
                    </ListItem>
                    <Divider />
                    <ListItem component={Link} to="/aboutApp">
                        <ListItemText primaryTypographyProps={{ style: listItemTextStyle }} primary="О приложении" />
                    </ListItem>
                    <Divider />
                    <ListItem onClick={handleLogout}>
                        <ListItemText primaryTypographyProps={{ style: listItemTextStyle }} primary="Выход" />
                    </ListItem>
                </List>
            </div>
        </>
    );
};

export default ProfilePage;
